{
  "welcome": "Welcome",
  "menu": {
    "LIVE": "Live",
    "HISTORY": "History",
    "TRACK": "Track",
    "PLACE": "Places",
    "VEHICLES": "Vehicles",
    "DEVICE": "Edge",
    "MESSAGES": "Messages",
    "TAGS": "Tags",
    "EDGE": "Edge",
    "ANALYTICS": "Analytics",
    "ADMIN": "Admin",
    "CUSTOMERS": "Customers",
    "SUPPORT-ADMIN": "Support Admin",
    "SUPPORT-USERS": "Support Users",
    "SUPPORT-ROLES": "Support Roles",
    "ALERTS": "Alerts",
    "OTA": "OTA",
    "SUPPORT-OTA": "OTA Campaign",
    "PODS": "PODS",
    "initiateOta": "Initiate OTA",
    "FIRMWARE": "Firmwares",
    "DASHBOARD": "Dashboard",
    "AL-DASHBOARD": "Dashboard",
    "FILES": "Files",
    "CAMPAIGN": "OTA Campaign",
    "configuration": "Configurations",
    "otaStatus": "OTA Status",
    "REPORT": "Reports",
    "USER": "Users",
    "GROUP": "Groups",
    "ROLE": "Roles",
    "SETTINGS": "Settings",
    "WHITELABEL": "Whitelabel",
    "HEADERS": "Device Headers",
    "CACHE-ATTRIBUTES": "Attributes",
    "RULES": "Rules",
    "DESTINATION": "Data Destinations",
    "PENDING": "New Order",
    "PROCESSED": "Fulfilled",
    "RegisteredVehicles": "Registered Vehicles",
    "AddNewVehicle": "Add/Update Vehicles",
    "UploadLogs": "Upload History",
    "RegisteredDevices": "Registered Devices",
    "AddNewDevice": "Add/Update Devices",
    "BENCH-TEST": "Bench",
    "TESTREADY": "Test Ready",
    "ADDDEVICE": "Add Device",
    "UPLOADHISTORY": "Upload History",
    "DELETEDDEVICE": "Deleted Device",
    "SUPPORT": "Support",
    "CUSTOMER": "Customer",
    "ORDER": "Orders",
    "ACCOUNTSEARCH": "Account Search",
    "USERINFO": "User Info",
    "DESTINATIONS": "Destinations",
    "TRIPS": "Trips",
    "TOOLS": "Tools",
    "CACHE": "Cache",
    "REPUBLISH": "Republish",
    "MOVE": "Move",
    "CONFIGURATION": "Configurations",
    "DATA": "Data",
    "DEVELOPER": "API Credentials",
    "SCORE": "Score",
    "PersonalInfo": "Personal Info",
    "VehicleInfo": "Vehicle Info",
    "PolicyInfo": "Policy Info",
    "MyNotifications": "My Notifications",
    "REPLACEMENT": "New Replacement",
    "REPLACEMENT_APPROVED": "Replacement Approved",
    "REPLACE_CONFIRMED": "Replacement Success",
    "REPLACE_REJECTED": "Replacement Rejected",
    "RETURN": "New Return",
    "RETURN_REJECTED": "Return Rejected",
    "RETURN_CONFIRMED": "Return Confirmed",
    "SUPPORT-DASHBOARD": "System Dashboard",
    "AUDIT-TRIAL": "Audit Trail",
    "GENERAL": "General",
    "MARKETPLACE": "Marketplace",
    "BILLING-REPORTS": "Billing Reports"
  },
  "locationShared": "Location Shared Successfully",
  "provisionUploadSuccess": "Certificates Uploaded Successfully",
  "provisionActivateSuccess": "Device Activated Successfully",
  "provisionActivateFail": "Device Activation Rejected.",
  "ruleSuccess": "Rule added successfully",
  "destinationSuccess": "Destination added successfully",
  "attrDeleteUser": "Attribute deleted.",
  "testedTrue": "Device marked as tested true",
  "customerCreated": "Customer added successfully",
  "customerUpdated": "Customer updated successfully",
  "addedAtrSuccess": "Attribute added successfully",
  "cacheDataSuccess": "Cache data added successfully",
  "replacementSuccess": "Replacement Initialted successfully",
  "ReportAddedSuccess": "Report added successfully",
  "cacheRebuildSuccess": "Cache rebuild successfully",
  "cacheInvalidateSuccess": "Cache invalidate successfully",
  "republishSuccessfully": "Republish successfully",
  "camoaignAddedSuccess": "Campaign added successfully",
  "campaignUpdatedSuccess": "Campaign Updated Successfully",
  "deviceCamoaignAddedSuccess": "Device added successfully in Campaign",
  "campaignBulkUploadSuccess": "File uploaded successfully, it will be processed in the background. Please check the uploaded logs for the result.",
  "campaignDeleteSuccess": "Campaign deleted successfully",
  "successAssociateDevice": "Device associated.",
  "successDeviceMove": "Devices Moved Successfully",
  "successCreateAlert": "Alert created.",
  "successUpdateAlert": "Alert updated.",
  "successDeleteAlert": "Alert deleted.",
  "successUpdateStatusDisabled": "Alert disabled.",
  "successUpdateStatusEnabled": "Alert enabled.",
  "successUpdateUserEnabled": "User activated successfully.",
  "successUpdateUserDisable": "User deactivated successfully.",
  "successCreatePlace": "Place created.",
  "successUpdatePlace": "Place updated.",
  "successDeletePlace": "Place deleted.",
  "successPlaceUpdateStatusDisabled": "Place disabled.",
  "successPlaceUpdateStatusEnabled": "Place enabled.",
  "successCreateDevice": "Devices created successfully.",
  "successDeleteDevice": "Device deleted successfully.",
  "successDeviceCsvFile": "Devices uploaded.",
  "successCreateVehicle": "Vehicles created.",
  "successDeleteVehicle": "Vehicle deleted.",
  "successDeleteFormware": "Firmware deleted.",
  "fileDelete": "File deleted.",
  "tokenGenerated": "Token Generated Successfully",
  "tokenDeleted": "Token Deleted Successfully",
  "orderCreated": "Order created successfully",
  "orderFulfilled": "Order fulfilled successfully",
  "orderDelivered": "Order delivered successfully",
  "replaceCreated": "Replacement Initiated Successfully",
  "replaceAuthorized": "Replacement Authorized Successfully.",
  "replaceRejected": "Replace Rejected Successfully.",
  "returnCreated": "Return Initiated Successfully.",
  "returnAuthorized": "Return Authorized Successfully.",
  "returnRejected": "Return Rejected Successfully.",
  "overwriteSuccess": "Device Overwritten Successfully.",
  "confirmSeededDevice": "Device Seed Confirmed Successfully.",
  "rejectSeededDevice": "Device Seed Rejected Successfully.",
  "returnComplete": "Return Completed Successfully.",
  "successDeleteConfig": "Configuration deleted.",
  "successVehicleCsvFile": "Vehicles uploaded.",
  "successFirmwareFile": "Firmware uploaded.",
  "successConfigFile": "Configuration uploaded.",
  "successFile": "File uploaded successfully.",
  "successCreateUser": "User created.",
  "successAssignReport": "Report(s) assigned Successfully.",
  "successUnassignReport": "Report unassigned Successfully.",
  "successAssignGroup": "Group(s) assigned Successfully.",
  "successUnassignGroup": "Group(s) unassigned Successfully.",
  "successUpdateUser": "User updated.",
  "successDeleteUser": "User deleted.",
  "successCreateGroup": "Group created.",
  "successUpdateGroup": "Group updated.",
  "successDeleteGroup": "Group deleted.",
  "successCreateRole": "Role created.",
  "successUpdateRole": "Role updated.",
  "successDeleteRole": "Role deleted.",
  "error401": "Please login to continue.",
  "errorNoChooseCsvFile": "Please upload a valid .CSV file.",
  "errorNoChoosexlsformatFile": " Please Upload a valid .XML , .XLS , .CSV  file.",
  "errorNoUploadType": "Please select Upload Type",
  "errorNoChoosefile": "Please Upload a file.",
  "verifyResetToken": "Password reset link is sent to your registered email. Please contact us if you have trouble setting your password.",
  "errorVerifyResetToken": "Password reset link is sent to your registered email. Please contact us if you have trouble setting your password.",
  "successResetPassword": "Password is reset. Please login with your new password.",
  "noInternet": "Internet Connection lost. Please ",
  "internetIsBack": "Internet Connection lost. Please ",
  "internetBack": "You're Online. Internet connection available",
  "successUpdateDevices": "Devices updated.",
  "successuploadDevices": "Devices upload Successfully.",
  "successUpdateVehicle": "Vehicles updated.",
  "successUpdateDevice": "Device updated.",
  "favUpdateSuccess": "Favorite updated Successfully.",
  "favAddSuccess": "Favorite added Successfully.",
  "favdeleteSuccess": "Favorite deleted Successfully.",
  "saveLocationSuccess": "Location Saved Successfully.",
  "deleteLocationSuccess": "Location Deleted Successfully.",
  "successUpdateProfile": "Your profile is updated.",
  "successUpdatePassword": "Your password is updated.",
  "successDevicesAddGroup": "Group assigned to selected devices successfully.",
  "successDevicesAddTag": "Tag assigned to selected devices successfully.",
  "sww": "Something went wrong",
  "successProfilePicture": "Your profile picture is updated.",
  "internalServerError": "Internal server error.",
  "successLogoUpload": "Logo is Updated.",
  "successRetryDevice": "Retry Device successful.",
  "successRetryAllDevice": "Retry Devices successful.",
  "successCancelAndRetryDevice": "Device Cancelled and Retry successful.",
  "successTriggerFlashDevice": "Device Triggered successfully.",
  "successDestinationAdded": "Destination Added Successfully.",
  "successDestinationUpdated": "Destination Updated Successfully.",
  "failureDestinationAdded": "Destination failed while adding.",
  "successConfigTest": "Configuration Test Success.",
  "successS3Test": "Configuration Test Success.",
  "failureConfigTest": "Configuration Test Failure.",
  "failureS3Test": "Configuration Test Failure.",
  "successDeleteDest": "Destination Deleted Successfully!",
  "failureDeleteDest": "Destination Deletion Failed!",
  "successDestToggle": "Destination enabled successfully!",
  "failureDestToggle": "Destination Toggle Failed!",
  "successSchemeAdd": "Scheme Added Successfully!",
  "successSchemeUpdate": "Scheme Updated Successfully!",
  "successSchemeEnabled": "Scheme Enabled Successfully!",
  "successSchemeDisabled": "Scheme Disabled Successfully!",
  "failureSchemeEnabled": "Failed Scheme while enable!",
  "failureSchemeDisabled": "Failed Scheme while Disable!",
  "successSchemeDelete": "Scheme Deleted Successfully!",
  "failureSchemeNF": "Failed while deleting scheme",
  "successDesEnabled": "Destination Enabled Successfully!",
  "successDestDisabled": "Destination Disabled Successfully!",
  "failureDestEnabled": "Failed Destination while enable!",
  "failureDestDisabled": "Failed Destination while Disable!",
  "successLabelCreate": "Label created successfully.",
  "campDescUpdateSuccess": "Description Updated Successfully.",
  "campLabUpdateSuccess": "Label Updated Successfully.",
  "saveSearchSuccess": "Search filter saved Successfully.",
  "successCreateTag": "Tag Created Successfully.",
  "successUpdateTag": "Tag Updated Successfully.",
  "successDeleteTag": "Tag Deleted Successfully.",
  "successUnlockUser": "Login attempts have been reset Successfully.",
  "successDeviceSimulation": "Simulation started successfully.",
  "failedDeviceSimulation": "Simulation failed.",
  "BL001": "Bill has not generated for the target data and customer",
  "BL002": "CustomerId cannot be null",
  "G21": "Please login to continue.",
  "GL001": "Method call is not supported.",
  "GL002": "Method call is not supported.",
  "GL003": "Request parameter is missing",
  "GL004": "Request payload is not valid, check your request payload.",
  "GL008": "Oops, file is missing in request.",
  "GL009": "Oops, the server encountered an internal error and was unable to complete your request. Please try after sometime or connect to our support.",
  "GL010": "Oops, your request cannot be authenticated, check your request.",
  "GL011": "Login to continue.",
  "GL012": "Oops, your request cannot be authenticated, check your request.",
  "GL013": "Oops, you do not have an access to this resource. Contact your account admin for further details..",
  "GL014": "First name is missing.",
  "GL015": "Last name is missing.",
  "GL016": "Email is missing.",
  "GL017": "Name is missing.",
  "GL018": "Mobile Number is missing.",
  "GL019": "Role is missing.",
  "GL020": "Vehicle VIN or ID is missing.",
  "GL021": "Vehicle does not exist.",
  "GL022": "Vehicle does not exist.",
  "GL023": "Display Name is missing.",
  "GL024": "File format is not proper.",
  "GL025": "File exceeds size limit.",
  "CU001": "Customer Type is missing.",
  "CU002": "Type is not valid.",
  "CU003": "Customer does not exist.",
  "CU004": "Address is missing.",
  "CU005": "Address 1 is missing.",
  "CU006": "City is missing.",
  "CU007": "State is missing.",
  "CU008": "Zip is missing.",
  "CU009": "Address Type is missing.",
  "CU010": "Address Type is not valid.",
  "CU011": "User Type is missing.",
  "CU012": "User Type is not valid.",
  "CU013": "Username already exists.",
  "CU014": "Username length exceeded.",
  "CU015": "User does not exist.",
  "CU016": "User does not exist.",
  "CU022": "CustomerID should be in Integer.",
  "CU030": "Support User does not have impersonate authority.",
  "CU032": "The backend user token is missing in header or not valid.",
  "CU033": "Username and password is missing in payload.",
  "CU034": "Username is missing.",
  "CU035": "Password is missing.",
  "CU036": "Username or password is not valid.",
  "CU037": "Account is locked due to multiple attempts.",
  "CU038": "Token does not exists.",
  "CU039": "Permission cannot empty.",
  "CU040": "Invalid permission",
  "CU041": "Module cannot be blank.",
  "CU042": "Invalid module",
  "CU043": "Modules name are not unique.",
  "CU044": "Module name already exists.",
  "CU045": "Password not found for user",
  "CU046": "User is missing.",
  "CU047": "Old Password is missing.",
  "CU048": "New Password is missing.",
  "CU049": "Your old password does not matched. Please try again. ",
  "CU050": "Unable to find a user",
  "CU051": "Unable to impersonate",
  "CU052": "Role does not exist.",
  "CU053": "Role is associated with users. To delete this role, need to de-associate user first.",
  "CU054": "Role is default role, this cannot be deleted.",
  "CU055": "Reset token is not valid.",
  "CU056": "Role belongs to different customer",
  "CU057": "Role cannot update",
  "CU058": "Default role cannot be update.",
  "CU059": "User cannot update his own role.",
  "CU060": "Module is already exists for customer",
  "CU061": "ExpiresIn cannot be null",
  "CU062": "You are not authorize to grant",
  "CU063": "Role name already exists.",
  "CU064": "Group not found with name",
  "CU066": "You have reached the maximum number of password reset attempts. Please contact customer support",
  "CU067": "Your account is temporarily suspended, please connect to the account admin.",
  "CU068": "User cannot be deactivated.",
  "CU069": "Please select atleast one message type.",
  "CU070": "No Data Found for selected Group.",
  "CU071": "Invalid email.",
  "CU072": "Your email is not whitelisted for a backend user creation. Please connect us at support@drivewithdarby.com for further assistance.",
  "LU077": "New password must be at least 12 characters and contain letters, numbers, and special characters. Weak or commonly used passwords are not allowed.",
  "AU014": "Body is missing.",
  "AU015": "Username is missing.",
  "AU016": "Company is missing.",
  "AU017": "Customer is missing.",
  "AU018": "Password is missing.",
  "AU019": "UserId is missing.",
  "AU020": "Username is already taken. Please try with new username.",
  "AL001": "Expression is not valid.",
  "AL002": "Alert Type already exists.",
  "AL003": "Invalid Device Type.",
  "AL004": "Alert type does not exists.",
  "AL005": "Oops, not authorized to update",
  "AL006": "Description cannot be null.",
  "AL007": "Expression cannot be null.",
  "DE001": "Key or Value already added in cache.",
  "DE002": "Key or Value is not defined in header.",
  "DE003": "Device not found with this Serial Number.",
  "DE004": "Device already exists",
  "DE005": "Device not found.",
  "DE006": "Device not found.",
  "DE007": "Serial Number {{0}} is duplicate .",
  "DE008": "IMEI is duplicate.",
  "DE009": "Key or Value cannot be null.",
  "DE010": "Default group cannot be deleted.",
  "DE011": "Group does not exists..",
  "DE012": "Default Group not found for customer.",
  "DE013": "Group name cannot be null.",
  "DE014": "Duplicate group name.",
  "DE015": "Group not found.",
  "DE016": "Some User already associated with group.",
  "DE017": "Some Device already associated with group.",
  "DE018": "Name cannot be null.",
  "DE019": "DisplayName cannot be null.",
  "DE020": "Type cannot be null.",
  "DE021": "Header is not for customer.",
  "DE022": "Header is already defined for customer.",
  "DE023": "Labels cannot be empty.",
  "DE024": "Label does not exists.",
  "DE025": "Label already exists with name for customer.",
  "DE026": "Invalid Label name .",
  "DE027": "User not found.",
  "DE028": "user does not have group assigned.",
  "DE029": "You cannot assign this group.",
  "DE030": "New Serial Number cannot be null.",
  "DE031": "Old Serial Number cannot be null.",
  "DE032": "New Serial Number and Old Serial Number is same.",
  "DE033": "Serial Number and IMEI is same.",
  "DE034": "Group does not belong to user.",
  "DE035": "Invalid data.",
  "DE036": "Cache data not found.",
  "DE037": "You are not authorised to do this operation.",
  "DE038": "Company Default Header has not defined.",
  "DE049": "Reached minimum required count, cannot de-associate",
  "DE050": "Value cannot be null.",
  "DE051": "Favorite already exists with same name.",
  "DE044": "Not supported Group",
  "DE045": "Group does not belongs to user",
  "DE046": "Group not found",
  "DE047": "CSV cannot be empty.",
  "DE048": "Product Serial Number is already exists.",
  "DE054": "Tag already exist.",
  "DE056": "Type code not valid.",
  "DE057": "Latlng and radius can not be empty.",
  "DE058": "SimCcid does not exists.",
  "DE059": "Cannot update Header Key [{0}]",
  "DE060": "[{0}] is System Type Device Header, cannot be deleted.",
  "DE061": "displayName already exists.",
  "DE062": "Only User type allowed to add. Make systemType as false.",
  "DE063": "Tag does not exists with name.",
  "DE064": "Tag does not exists with Id",
  "DE065": "Tag name is mandate.",
  "DE066": "Tag associated with devices.",
  "DE067": "Tag update request already exists.",
  "DE068": "Data Scheme name already exists",
  "DE069": "Something went wrong while retrieving message types",
  "DE070": "Something went wrong while enabling/disabling toggle",
  "DE071": "Something went wrong while retrieving schemes",
  "DE072": "Something went wrong while retrieving Destinations",
  "DES011":"Please select atleast one group",
  "GF001": "Fence Name is missing.",
  "GF002": "Fence does not exist.",
  "GF003": "Alert Type is missing.",
  "GF004": "Place type (Circle or Polygon) is missing.",
  "GF005": "Radius is missing.",
  "GF006": "Centre is missing.",
  "GF007": "Vertex is missing.",
  "GF008": "Invalid Alert Type",
  "GF009": "Conflict by vehicle VIN and ID - send one at a time.",
  "GF010": "Fence is already associated with vehicle",
  "GF011": "Fence is already associated with VIN",
  "GF012": "Fence is not associated with vehicle",
  "GF013": "Invalid Notification Type;",
  "GF014": "End time cannot be greater than start time.",
  "GF015": "End time cannot be before current time.",
  "CF001": "Invalid tag name.",
  "CF002": "Key not found with name.",
  "CF003": "Invalid Key data type",
  "CF004": "Key already exists with name.",
  "CF005": "Data Type is missing.",
  "MG001": "Start time cannot be in future.",
  "MG002": "End time cannot be in future.",
  "MG003": "Start time cannot be after end time.",
  "MG004": "Date difference cannot be more than a month.",
  "MG005": "Invalid expression.",
  "MG006": "End time is invalid.",
  "MG008": "Key or Value cannot be blank",
  "MG009": "Invalid status",
  "MG010": "Invalid OR condition",
  "MG011": "{ is missing from condition.",
  "MG012": "Condition is missing.",
  "MG013": "Operand is missing for condition.",
  "MG014": "Operand cannot be blank.",
  "MG015": "( is missing for condition.",
  "MG016": ") is missing for condition.",
  "MG017": "LTE or GTE will accept only number.",
  "MG018": "Query cannot be null.",
  "MG019": "Filter parse error.",
  "MG020": "Is condition will accept Boolean only",
  "MG021": "} is missing",
  "MG023": "Invalid value",
  "MG024": "Group does not belongs to user",
  "MG025": "Invalid Key",
  "MG026": "Date difference cannot be more than a 15 days.",
  "MG027": "Device KAFKA metric is not defined.",
  "MG028": "Kafka Tag is not defined.",
  "MG029": "Forbidden.",
  "RP001": "Start time and end time cannot be 0",
  "RP002": "Report Name is missing.",
  "RP003": "Start time cannot be greater than end time.",
  "RP004": "Time difference can not be more than a day.",
  "RP005": "Attribute is missing.",
  "RP006": "Report Id is missing.",
  "RP007": "Columns is missing.",
  "RP008": "Report does not exist.",
  "RP009": "Report Type does not exist.",
  "RP010": "SPN is missing.",
  "RP011": "FMI is missing.",
  "RP012": "Error Code is missing.",
  "RP013": "Description is missing.",
  "RP014": "Reactive is missing.",
  "RP015": "SPN_FMI is missing.",
  "RP016": "ECU Name is missing.",
  "RP017": "SourceId is missing.",
  "RP018": "ECU Description is not null.",
  "RP026": "VisualizationType cannot be null",
  "RP027": "Wrong report to serve",
  "RP028": "report will accept two params only",
  "RP049": "Vehicle type should be BS4 or BS6.",
  "RP050": "No records found in the attached file.",
  "RP051": "CSV header mismatch.",
  "RP052": "Schedule Report not processed",
  "RP053": "Invalid Report to serve with this API",
  "RP054": "Invalid request, device does not exists",
  "RP055": "Architecture Type is not defined for this device.",
  "OTA002": "File name already exists {{0}}.",
  "OTA005": "FileName cannot be blank.",
  "OTA007": "File cannot be deleted, uploaded file is associated with some campaign.",
  "OTA014": "Active or null campaign cannot be deleted.",
  "OTA015": "Campaign Name already exists.",
  "OTA016": "Device can be cancelled, only with campaign status SCHEDULED or PROGRESS.",
  "OTA017": "Campaign and device does not match or device does not exist with status SCHEDULED or PROGRESS.",
  "OTA018": "Campaign does not exists",
  "OTA021": "File name allowed special character (.,-,_)",
  "OTA022": "Unable to connect file server.",
  "OTA025": "Cannot add devices, campaign is already cancelled.",
  "OTA026": "Cannot add devices in the provisioning campaign.",
  "OTA027": "Not Authorised to delete this file.",
  "OTA028": "Retry is only applicable when status is CANCELLED OR FAILED.",
  "OTA029": "Retry can be triggered only 5 times.",
  "OTA030": "Device does not exist.",
  "OTA031": "Campaign type cannot be null.",
  "OTA032": "Invalid campaign type.",
  "OTA033": "Ecu Group and Ecu Name does not match.",
  "OTA034": "The device can be triggered only with status DOWNLOAD_SUCCESS",
  "OTA036": "Label already exists.",
  "OTA037": "Label does not exists for user.",
  "OTA038": "Campaign Name cannot be null",
  "OTA039": "More than 5 files are not allowed",
  "OTA040": "Oops, this device {{0}} cannot be assigned to this campaign as it open in another campaign .",
  "OTA041": "Wrong File Type",
  "OTA042": "Customer cannot be null or empty",
  "OTA043": "It cannot be null.",
  "OTA044": "CSV cannot be empty.",
  "OTA045": "Invalid key.",
  "OTA046": "Label cannot be assign by support user",
  "OTA049": "Invalid Action.",
  "OTA050": "Description can not be more than 100.",
  "OTA051": "Invalid status.",
  "CPN001": "Campaign Name cannot be null",
  "CPN002": "Description cannot be null",
  "CPN003": "Listener Type cannot be null",
  "CPN004": "File Type cannot be null",
  "CPN005": "File Name cannot be null",
  "CPN006": "Uploaded File name cannot be null",
  "CPN007": "Device cannot be null or empty",
  "CPN008": "Cron Date time cannot be null",
  "CPN009": "Cannot Initiate OTA",
  "CPN010": "Wrong Listener Type",
  "CPN011": "Wrong File Type",
  "CPN013": "Only Campaign with status Schedule can be cancelled",
  "CPN014": "Campaign trigger date should be later date",
  "OD0001": "Tracking number cannot be empty",
  "OD0002": "Carrier cannot be empty",
  "OD0003": "Devices cannot be empty",
  "OD0004": "Invalid Carrier",
  "OD0005": "Devices size mismatched with order",
  "OD0006": "Order not found",
  "OD0007": "Device count should be non-zero",
  "OD0008": "Email cannot be empty",
  "OD0009": "CompanyId cannot be empty",
  "OD0010": "CustomerId cannot be empty",
  "OD0011": "OrderType cannot be empty",
  "OD0012": "Address cannot be empty",
  "OD0013": "Invalid order type",
  "OD0014": "FirstName cannot be empty",
  "OD0015": "LastName cannot be empty",
  "OD0016": "Address1 cannot be empty",
  "OD0017": "Address2 cannot be empty",
  "OD0018": "Device already associated",
  "OD0019": "Order is not yet fulfilled",
  "OD0020": "Order is not shipped",
  "OD0021": "City cannot be empty",
  "OD0022": "State cannot be empty",
  "OD0023": "Country cannot be empty",
  "OD0024": "Zip cannot be empty",
  "OD0025": "Mobile number cannot be empty",
  "OD0026": "Tenant not found",
  "OD0027": "RequestId cannot be null",
  "OD0028": "Tenant Name cannot be null",
  "OD0029": "Device cannot null or empty",
  "OD0030": "Product code cannot null or empty.",
  "OD0031": "Manufacturing Country cannot null or empty.",
  "OD0032": "Manufacture Date cannot null or empty.",
  "OD0033": "Factory code ca not null or empty.",
  "OD0034": "Manufacturer cannot null or empty.",
  "OD0035": "Product Revision cannot null or empty.",
  "OD0036": "SimCcid cannot null or empty.",
  "OD0037": "Product Serial Number cannot null or empty.",
  "OD0038": "CarrierType cannot null or empty.",
  "OD0039": "SimCarrier1 cannot null or empty.",
  "OD0040": "SimCarrier2 cannot null or empty.",
  "OD0041": "Hardware Compatibility Code cannot null or empty.",
  "OD0042": "Generation cannot null or empty.",
  "OD0043": "Serial Number cannot be null.",
  "OD0044": "Invalid Key.",
  "OD0045": "IMEI cannot be empty",
  "OD0046": "Order is not eligible for approval",
  "OD0047": "Order is not eligible for add replace device",
  "OD0048": "Replace device do not belong to same customer",
  "OD0049": "Device not found with Serial Number ",
  "OD0050": "Replace Order not found with Id",
  "OD0051": "VIN cannot be null.",
  "OD0052": "Return Serial Number cannot be null.",
  "OD0053": "Replace Serial Number cannot be null.",
  "OD0054": "Return Shipment date cannot be null.",
  "OD0055": "Replace Shipment date cannot be null.",
  "OD0056": "Device is being already associated",
  "CS0002": "Carrier not found with name",
  "PS001": "Customer cannot be null",
  "PS002": "Destination type cannot be null",
  "PS003": "Props cannot be null",
  "PS004": "Property cannot be null",
  "PS005": "Invalid token Position",
  "PS006": "Invalid destination type",
  "PS007": "Already configured with the details",
  "PS008": "Destination Type Not Supported",
  "PS009": "Duplicate Rule",
  "PS010": "MessageType cannot be null",
  "PS011": "Destination not found with name",
  "PS012": "Parents cannot be null",
  "PS013": "Child name cannot be null",
  "PS014": "Child's column cannot be null",
  "PS015": "Source Key cannot be null",
  "PS016": "Destination Key cannot be null",
  "PS017": "Invalid Level",
  "PS018": "Destination name cannot be null",
  "PS019": "Destination Key cannot be null",
  "PS020": "Destination cannot be null",
  "PS021": "Invalid end point",
  "PL019": "Place already exists.",
  "GWI001": "IMEI cannot be empty",
  "GWI002": "EventId cannot be empty",
  "GWI003": "Not Found IMEI with Serial Number",
  "GWI004": "Invalid scope",
  "VE001": "No device exists with an IMEI",
  "VE002": "Device already associated.",
  "VE003": "Serial Number cannot be null.",
  "VE004": "IMEI cannot be null.",
  "VE005": "Serial Number is already exists.",
  "VE006": "IMEI already exists.",
  "VE007": "Device not found ID.",
  "VE008": "Serial Number does not exists.",
  "VE009": "Device is not tested.",
  "VE010": "VIN cannot be null.",
  "VE011": "VIN already exists.",
  "VE012": "VIN is already associated with other vehicle.",
  "VE013": "Key or Value cannot be null.",
  "VE015": "Preference already exists",
  "VE016": "Group Not found with id.",
  "VE017": "Group Name should not be blank",
  "VE018": "Group already exists with name.",
  "VE019": "Default group cannot be deleted",
  "VE020": "Group cannot be deleted when associated with any device or group.",
  "VE021": "Tag name is not valid.",
  "VE022": "Attribute is not valid.",
  "VE023": "Attribute is not defined.",
  "VE024": "Attribute already defined.",
  "VE025": "Header Tag Name is already exists.",
  "VE026": "Header Tag Name not exists.",
  "VE027": "Key not found with name.",
  "VE028": "Type cannot be null.",
  "VE029": "Associated device cannot be deleted.",
  "VE030": "Invalid value",
  "VE031": "Group does not belongs to user.",
  "VE032": "Group not found with name.",
  "VE033": "User is not eligible to update Serial Number.",
  "VE037": "Tags cannot be blank.",
  "VE038": "Invalid tag name.",
  "VE039": "CSV cannot be empty.",
  "VE040": "Tags must be in array.",
  "VE071": "Carrier not defined for Serial Number.",
  "VE072": "Date difference cannot be more than a 15 days.",
  "VE075": "Device already provisioned.",
  "VE076": "Activation Type cannot be null.",
  "VE077": "Engine Number cannot be null.",
  "VE078": "Architecture Type cannot be null.",
  "VE079": "Invalid Request Flag, supported are S, C, R, D, and RA.",
  "VE080": "Invalid Device ID.",
  "VE082": "Product Serial Number is already exists.",
  "VE083": "New Serial Number cannot be null.",
  "VE084": "Old Serial Number cannot be null.",
  "VE085": "Attribute already exists in header.",
  "VE086": "Duplicate entry found  in payload for Serial Number.",
  "VE087": "Duplicate entry found  in payload for IMEI.",
  "VE088": "Duplicate entry found  in payload for product Serial Number.",
  "VE044": "CSV header mismatch.",
  "VE045": "Invalid Key.",
  "ANL004": "Start Time cannot be blank",
  "ANL005": "End Time cannot be blank",
  "ANL006": "Invalid date format.",
  "ANL007": "Serial Number does not exists.",
  "ALVP001": "No config found",
  "ALVP039": "No change found in Form!",
  "ALVP040": "Error found in Form!",
  "ALVP041": "Please select the device",
  "ALVP002": "Invalid product serial number.",
  "ALVP003": "Invalid status",
  "ALVP004": "VAHAN registration is already processed.",
  "ALVP005": "Device does not exists",
  "ALVP006": "Assets are missing.",
  "ALVP007": "Invalid notify value - it should be Yes/No",
  "ALVP008": "Invalid requestId.",
  "ALVP009": "Invalid product serial number",
  "ALVP010": "Invalid PSN and RequestId combination",
  "ALVP011": "No data found.",
  "ALVP012": "Request Flag is missing.",
  "ALVP013": "Invalid Request Flag",
  "ALVP014": "VIN is missing.",
  "ALVP015": "Device ID is missing",
  "ALVP016": "Activation Request Date is missing.",
  "ALVP017": "Fuel Tank Capacity is missing.",
  "ALVP018": "Vehicle Type is missing.",
  "ALVP019": "Battery Voltage is missing.",
  "ALVP020": "Fuel Sensor Fitted is missing.",
  "ALVP021": "External Fuel Sensor is missing.",
  "ALVP022": "Pulley Ratio is missing.",
  "ALVP023": "Engine number is missing.",
  "ALVP024": "Vehicle Registration Number is missing.",
  "ALVP025": "AIS 140 Status is not valid.",
  "ALVP026": "Root Folder Path is missing.",
  "ALVP027": "Address Proof Path is missing.",
  "ALVP028": "ID Proof S3 Path is missing.",
  "ALVP029": "PAN S3 Path is missing.",
  "ALVP030": "Address is missing.",
  "ALVP031": "Mobile Number is missing.",
  "ALVP032": "Authorized Personnel Name is missing.",
  "ALVP033": "Already provisioned with VIN",
  "ALVP034": "S trigger not found",
  "ALVP035": "KYC is already Done",
  "ALVP036": "VIN mismatch with S and C request",
  "ALVP037": "Invalid value for device status",
  "ALVP038": "KYC already processed for this.",
  "ALVP044": "Invalid serial number.",
  "DA001": "Query must not be null",
  "DA002": "Incomplete condition",
  "DA003": "Undefined column",
  "DA004": "Invalid condition",
  "DA005": "Invalid operator",
  "DA006": "Query data is empty",
  "DA007": "Sorting is not defined properly",
  "DA008": "Sorting key is not defined in header",
  "DA009": "Order is not defined properly",
  "DF001": "Filter not found with Id.",
  "DF002": "Filter not found with name.",
  "DF003": "Name cannot be null.",
  "DF004": "Query cannot be null.",
  "DF005": "Name already exists.",
  "DF006": "Query is not valid.",
  "UPS014": "Structure is not defined",
  "AT001": "sessionId not found",
  "MFA001": "OTP did not matched, please try again.",
  "MFA002": "Mfa type cannot be updated.",
  "MFA003": "Invalid Mfa type.",
  "MFA004": "Too many attempts.",
  "MFA005": "Reached the Max OTP retry limit.",
  "MFA006": "No active OTP, please login with username & password",
  "MFA007": "OTP expired.",
  "01": "Package not available",
  "02": "download failed or connection failure",
  "03": "Package corrupted",
  "04": "Program failed",
  "05": "Unknown",
  "undefined": "Internal server error.",
  "timeOut": 5000,
  "successDebugLogsActivated": "Debug logs activated successfully",
  "successDebugLogsDeactivated": "Debug logs deactivated successfully",
  "successuploadGroups": "Groups uploaded successfully."
}